<!--
	作者：shujuan sun
	时间：2017-04-10
	描述：车辆状态图标
-->
<template>
	 <!--车辆监控页面_车辆状态解释开始-->
	<div class="icon_indicated picc_car" :class="{'activ_magnify':magnify,'midSizeL':leftSize==1,'maxSizeL':leftSize==2,'minSizeL':leftSize==0}"> 
	  <ul>
	  	<li class="li_text">车辆：</li>
	  	<li>
	  		<em>
	  			<input type="checkbox" v-model="carType1"/> 
	  		</em>
	  		<em class="li_text_car">
	  			<img src="../../../assets/project/images/car/trail_leisure_t.png" height="24" alt=""/>
	  		</em> 
	  		<span class="li_text_txt">拖车</span>
	  	</li>
	  	<li class="li_line">
	  		<em>
	  			<input type="checkbox" v-model="carType2"/> 
	  		</em>
	  		<em class="li_text_car">
	  			<img src="../../../assets/project/images/map/car_icon_11.png" width="14" height="24" alt=""/>
	  		</em>
	  		<span class="li_text_txt">路修车</span>
	  	</li>
	    <li class="bgc_01">
	    	<em>
	    		<input type="checkbox" v-model="carStatus1"/>
	    	</em>
	    	<span>空闲中</span>
	    </li>
	    <li class="bgc_03">
	    	<em>
	    		<input type="checkbox" v-model="carStatus2"/>
	    	</em>
	    	<span>已暂停</span>
	    </li>
	    <li class="bgc_05">
	    	<em>
	    		<input type="checkbox" v-model="carStatus3"/>
	    	</em>
	    	<span>救援中</span>
	    </li>
	  </ul>
	</div>
	  <!--车辆监控页面_车辆状态解释结束-->
</template>
<script>
	import {mapState} from 'vuex'
	export default{
		name:'MenuStatus',
		data(){
			return {
			//	carType:['0','1'],
			//	carStatus:['0','1','2']
				carType1:true,
				carType2:true,
				carStatus1:false,
				carStatus2:false,
				carStatus3:true
				
			}
		},
		computed:mapState({ 
			leftSize:state=>state.monitor.leftSize,
			magnify:state=>state.monitor.magnify
		}),
		watch:{
			carType1(val){
				if(!this.carType1 && !this.carType2){//如果同时取消选中车辆类型，所有复选框为空
					this.carStatus1 = false
					this.carStatus2 = false
					this.carStatus3 = false
				}
				if(this.carType1 && !this.carStatus1 && !this.carStatus2 && !this.carStatus3){
					this.carStatus1 = true
					this.carStatus2 = true
					this.carStatus3 = true
				}
				this.$emit('carTypeOnMap1',val)
			},
			carType2(val){
				if(!this.carType1 && !this.carType2){//如果同时取消选中车辆类型，所有复选框为空
					this.carStatus1 = false
					this.carStatus2 = false
					this.carStatus3 = false
				}
				if(this.carType2  && !this.carStatus1 && !this.carStatus2 && !this.carStatus3){
					this.carStatus1 = true
					this.carStatus2 = true
					this.carStatus3 = true
				}
				this.$emit('carTypeOnMap2',val)
			},
			carStatus1(val){
				if(!this.carStatus1 && !this.carStatus2 && !this.carStatus3){//如果同时取消选中车辆状态，所有复选框为空
					this.carType1 = false
					this.carType2 = false
				}
				if(val && !this.carStatus2 && !this.carStatus3){
					this.carType1 = true
					this.carType2 = true
				}
				this.$emit('carStatusOnMap1',val)
			},
			carStatus2(val){
				if(!this.carStatus1 && !this.carStatus2 && !this.carStatus3){//如果同时取消选中车辆状态，所有复选框为空
					this.carType1 = false
					this.carType2 = false
				}
				if(val && !this.carStatus1 && !this.carStatus3){
					this.carType1 = true
					this.carType2 = true
				}
				this.$emit('carStatusOnMap2',val)
			},
			carStatus3(val){
				if(!this.carStatus1 && !this.carStatus2 && !this.carStatus3){//如果同时取消选中车辆状态，所有复选框为空
					this.carType1 = false
					this.carType2 = false
				}
				if(val && !this.carStatus2 && !this.carStatus1){
					this.carType1 = true
					this.carType2 = true
				}
				this.$emit('carStatusOnMap3',val)
			}
		}
	}
</script>

<style scoped>
.icon_indicated{
	opacity: 1;
}
.li_text_car{
	margin-left:20px;
}
.li_text_txt{
	margin-left:23px;
}
</style>


// WEBPACK FOOTER //
// MenuStatus.vue?1385e46e